export default __webpack_public_path__ + "20945b5179dc0db968cbbd66bc97b9ee.png";